<div class="lvi-content">
    <div class="avatar" [nSelector]="{ liste: liste, item: data }">
        <i class="material-icons-outlined">person</i>
    </div>
    <div class="lvi-body">
        <div class="title">
            <span class="label">{{ data.libelle }}</span>
        </div>
        <ul class="lvi-attrs">
            <li>
                <strong [translate]="'admin.bibliotheque.notifications.accueil.detail.tag.profil'"></strong>
                <span>{{ TypeProfil.getLibelle(translateService, data.fonction) }}</span>
            </li>
        </ul>
    </div>
</div>
